import React from 'react';

export function Logo() {
  return (
    <div className="flex items-center gap-3">
      <svg width="58" height="58" viewBox="0 0 64 64" fill="none">
        <rect width="64" height="64" rx="16" fill="#0f172a" />
        <rect x="1" y="1" width="62" height="62" rx="15" stroke="#1e3a5f" strokeWidth="1.5"/>
        <path d="M18 20 L12 32 L18 44" stroke="#38bdf8" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
        <path d="M46 20 L52 32 L46 44" stroke="#38bdf8" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
        <text x="50%" y="55%" dominantBaseline="middle" textAnchor="middle" style={{fontSize: '18px', fontWeight: 800, fill: 'white', fontFamily: 'Inter, sans-serif', letterSpacing: '-0.05em'}}>ME</text>
      </svg>
      <div className="flex flex-col justify-center">
        <div className="flex items-baseline leading-none" style={{ fontFamily: 'Inter, sans-serif' }}>
          <span className="text-[#38bdf8] font-[800] text-2xl tracking-tight">M</span>
          <span className="text-white font-[800] text-2xl tracking-tight">edia</span>
          <span className="w-1.5"></span>
          <span className="text-[#38bdf8] font-[300] text-2xl tracking-tight">E</span>
          <span className="text-white font-[300] text-2xl tracking-tight">xperto</span>
        </div>
        <div className="text-[#38bdf8] text-[10px] font-bold uppercase tracking-[0.2em] mt-0.5" style={{ fontFamily: 'Inter, sans-serif' }}>
          DESARROLLO WEB & APPS
        </div>
      </div>
    </div>
  );
}
